import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import { BreadcrumbModule } from "primeng/breadcrumb";

import { FileService } from "../../services/shared/file.service";
import { ImagePipe } from "../../utils/pipes/shared/image.pipe";
import { BaseApiService } from "../../services/shared/base.api.service";
import { BaseMapper } from "../../utils/mappers/shared/base.mapper";
import { SharedMapper } from "./shared.mapper";
import { SharedMapper as SharedMapper2 } from "../../utils/mappers/shared/_shared.mapper";
import { PagelayoutcardedComponent } from "./components/pagelayoutcarded/pagelayoutcarded.component";
import { PagelayoutFullComponent } from "./components/pagelayoutfull/pagelayoutfull.component";
import { DialogContentComponent } from "./components/dialog-content/dialog-content.component";
import { TableComponent } from "./components/table/table.component";
import { CdkTableModule } from "@angular/cdk/table";
import { MatTableModule } from "@angular/material/table";
import { MaterialModule } from "../../utils/modules/core/modules/material.module";
import { TemplateLoaderDirective } from "../../utils/directives/shared/template-loader.directive";
import { DataTypeTemplatesComponent } from "./components/data-type-templates/data-type-templates.component";

import { FormInputComponent } from "./components/dynamic-form/controls/form-input/form-input.component";
import { FormSelectComponent } from "./components/dynamic-form/controls/form-select/form-select.component";
import { FormRadioComponent } from "./components/dynamic-form/controls/form-radio/form-radio.component";
import { ProfileComponent } from "./components/profile/profile.component";
import { ProfileAboutComponent } from "./components/about/about.component";
import { DatePickerComponent } from "./components/dynamic-form/controls/date-picker/date-picker.component";
import { TextAreaComponent } from "./components/dynamic-form/controls/text-area/text-area.component";
import { ErrorsIndicatorComponent } from "./components/dynamic-form/controls/errors-indicator/errors-indicator.component";
import { ErrorsListModalComponent } from "./components/dynamic-form/controls/errors-list-modal/errors-list-modal.component";
import { FormTableComponent } from "./components/dynamic-form/controls/form-table/form-table.component";
import { MatSectionComponent } from "./components/mat-section/mat-section.component";
import { FormCheckComponent } from "./components/dynamic-form/controls/form-check/form-check.component";
import { SharedCatalogService } from "../../services/shared/sharedcatalog.service";
import { DateFormatPipe } from "../../utils/pipes/shared/dateFormat";
import { DataTableComponent } from "./components/datatable/datatable.component";
import { NgxDatatableModule } from "@siemens/ngx-datatable";
import { SpinnerButtonDirective } from "../../utils/directives/shared/spinner-button";
import { FilterPanelComponent } from "./components/filter-panel/filter-panel.component";
import { FlexLayoutModule } from "@ngbracket/ngx-layout";
import { HasPermissionDirective } from "../../utils/directives/shared/has-permission";
import { TagInputComponent } from "./components/tag-input/tag-input.component";
import { TagInputModule } from "ngx-chips";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { HttpClient } from "@angular/common/http";
import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { BreadcrumbComponent } from "./components/breadcrumb/breadcrumb.component";
import { FormComponent } from "./components/dynamic-form/form/form.component";
export function HttpLoaderFactory(http: HttpClient) {
    return new TranslateHttpLoader(http, "./assets/i18n/", ".json");
}

@NgModule({
    imports: [
        FlexLayoutModule,
        CommonModule,
        BreadcrumbModule,
        FormsModule,
        ReactiveFormsModule,
        CdkTableModule,
        MatTableModule,
        MaterialModule,
        NgxDatatableModule,
        TagInputModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient],
            },
        }),
    ],
    declarations: [
        ImagePipe,
        DateFormatPipe,
        DataTableComponent,
        TableComponent,
        PagelayoutcardedComponent,
        PagelayoutFullComponent,
        TemplateLoaderDirective,
        DataTypeTemplatesComponent,
        FormInputComponent,
        FormSelectComponent,
        FormComponent,
        FormRadioComponent,
        DialogContentComponent,
        ProfileComponent,
        ProfileAboutComponent,
        DatePickerComponent,
        TextAreaComponent,
        ErrorsIndicatorComponent,
        ErrorsListModalComponent,
        FormTableComponent,
        MatSectionComponent,
        FormCheckComponent,
        SpinnerButtonDirective,
        HasPermissionDirective,
        FilterPanelComponent,
        TagInputComponent,
        BreadcrumbComponent,
    ],
    providers: [
        FileService,
        BaseApiService,
        BaseMapper,
        SharedMapper,
        SharedMapper2,
        SharedCatalogService,
    ],
    exports: [
        TableComponent,
        DataTableComponent,
        PagelayoutcardedComponent,
        PagelayoutFullComponent,
        ImagePipe,
        DateFormatPipe,
        MaterialModule,

        DialogContentComponent,
        ProfileComponent,
        ProfileAboutComponent,
        MatSectionComponent,
        SpinnerButtonDirective,
        HasPermissionDirective,
        FilterPanelComponent,
        TagInputComponent,
    ],
})
export class SharedModule {}
